import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { UserPromptService } from '../../../pages/pages/user-prompts/user-prompt.service';
import { DIALOG_DATA } from '../../../../global.variable';
import { Router } from '@angular/router';

@Component({
  selector: 'gtapp-add-mobile-form',
  standalone: false,
  templateUrl: './add-mobile-form.component.html',
  styleUrl: './add-mobile-form.component.scss',
})
export class AddMobileFormComponent implements OnInit, OnDestroy {
  userPromptsSearchResults: any = [];
  userPromptsSearchResultsCopy: any = [];
  userPromptTotalCount: number = 0;
  selectedPromptIds: any = [];

  constructor(
    protected dialogRef: DialogRef,
    private userPromptService: UserPromptService,
    @Optional() @Inject(DIALOG_DATA) public dialogueData: any,
    private router: Router,
  ) {}

  ngOnDestroy(): void {}
  ngOnInit(): void {
    this.selectedPromptIds =
      this.dialogueData?.selectedPromptIds || this.selectedPromptIds || [];
    this.getUserPrompts({}, true);
  }

  onCloseDialog(val: any) {
    this.dialogRef.close(val);
  }
  searchPrompts(event: any) {
    if (event.target.value?.length <= 2) return;
    const params: any = { search_str: event.target.value };
    this.getUserPrompts(params);
  }
  getUserPrompts(params?: any, initialCall = false) {
    this.userPromptService
      .getUserPromptList(params)
      .subscribe((response: any) => {
        const resultData = response?.data || [];

        if (initialCall) {
          this.userPromptTotalCount = response?.total_size;
          if (!this.userPromptTotalCount) {
            this.router.navigate(['/mobile-form']);
            return;
          }
          this.userPromptsSearchResultsCopy = JSON.parse(
            JSON.stringify(resultData?.splice(0, 3)),
          );
        }
        this.userPromptsSearchResults = resultData?.filter(
          (searchPrompt: any) =>
            !this.userPromptsSearchResultsCopy?.some(
              (prompt: any) => prompt?.id == searchPrompt?.id,
            ),
        );
      });
  }
  onPromptSelect(promptData: any) {
    const alreadyPresent = this.selectedPromptIds?.some(
      (prompt: any) => prompt == promptData?.id,
    );

    if (alreadyPresent) {
      this.selectedPromptIds = this.selectedPromptIds?.filter(
        (prompt: any) => prompt != promptData?.id,
      );
    } else {
      this.selectedPromptIds.push(promptData?.id);
    }
  }
}
